import { Box, Divider, FormControlLabel, styled } from '@mui/material';

export const StyleDivider = styled(Divider)(
  ({ theme }) => `
      margin-top:8px;
        border-bottom: 1px solid ${theme.palette.brand?.black};
      `,
);

export const LocationContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
  margin-top: 20px;
`;

export const LocationSectionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GridContainer = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  overflowX: 'hidden',
  border: `1px solid ${theme.palette.grey[100]}`,
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
}));

export const StyledGridHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: '8px 10px',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

export const CheckboxLabel = styled(FormControlLabel)`
  padding: 5px;
  font-size: 16px;
  font-family: 'Roboto';
  .MuiFormControlLabel-label {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
